import React from "react";
import styles from "./ProductCategories.module.css";

import Grid from "@material-ui/core/Grid";
import {
  CardCategoriesHeader,
  CardCategoriesList,
  HelperSlider,
} from "components/CardCategories";

const ProductCategories = () => {
  return (
    <section className={styles.section}>
      <div className={styles.item}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={9}>
            <CardCategoriesHeader />
            <CardCategoriesList />
          </Grid>

          <Grid item xs={12} sm={3}>
            <HelperSlider />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ProductCategories;
